export default __webpack_public_path__ + "static/media/collections_icon_black.dea1af02.svg";